export const CopyrightSection = ({ legalEntity }) => {
  const currentYear = new Date().getFullYear();

  return (
    <div className="mt-6 flex justify-center stihl-text-body-xs-bold stihl-page-container">
      Copyright &copy; {currentYear} {legalEntity}
    </div>
  );
};
